
export function loadLang(lang) {
    return localeObj[lang]
}

const localeObj = {


    
    'cn': {
 
        tutorials1: '下载问题',
        tutorials2: '连接问题',
        tutorials3: '赚取佣金',
        tutorials4: '其它问题',
        tutorials5: 'QUESTIONS',
        tutorials6: 'When the title exceeds the length limit, it will be displayed on a new line?',
        tutorials7: 'question title',
        tutorials8: '',
        tutorials9: '',
        tutorials10: '',
        tutorials11: '',
        tutorials12: '',
        tutorials13: '',
        tutorials14: '',
        tutorials15: '',
        tutorials16: '',
        tutorials17: '',
        tutorials18: '',
        tutorials19: '',
        tutorials20: '',
        tutorials21: '',
        tutorials22: '',
        tutorials23: '',
        tutorials24: '',
        tutorials25: '',
        tutorials26: '',
        tutorials27: '',
        tutorials28: '',
        tutorials29: '',

       /* 
        home10: '',
        home11: '',
        home12: '',
        home13: '',
        home14: '',
        home15: '',
        home16: '',
        home17: '',
        home18: '',
        home19: '',
        home20: '',
        home21: '',
        home22: '',
        home23: '',
        home24: '',
        home25: '',
        home26: '',
        home27: '',
        home28: '',
        home29: '', */
        
        home10: ' 永久免费 一键加速全网',
        home11: '永久免费，适合游戏、影音、直播、办公等多种需求；不限设备数，不限速，海量专线带宽，更快更稳定更安全！',
        home12: '(免费使用)',
        home13: '更多客户端',
        home14: '下载即可使用 无需绑定账号',
        home15: '不限设备数',
        home16: '的加速器',
        home17: '多设备同时登录，办公娱乐更便捷',
        home18: 'Windows',
        home19: 'Android',
        home20: 'iOS',
        home21: 'macOS',
        home22: '随时随地 畅游',
        home23: '全球所有平台',
        home24: '尽情畅享更私密、更安全的互联网，阻止网络跟踪器',
        home25: '为什么选择绝尘加速器',
        home26: '极速体验',
        home27: '真正的不限速，致力带给您 如同本地网路般的上网体验',
        home28: '不限设备数',
        home29: '下载即可使用 无需绑定账号，多设备同时在线，工作娱乐更便捷',
        home30: '极限低延迟',
        home31: '海量专线带宽，致力提供接近极限的低延迟',
        home32: '日套餐 随用随开',
        home33: '全网唯一一家敢提供日套餐，什么时候用就什么时候开，永不担心被套牢。',
        home34: '行业领先的加密技术',
        home35: '通过 256 位 AES 加密、DNS/IPv6泄漏保护和终止开关来保护您的数据和在线活动。',
        home36: '卓越的客服团队',
        home37: '365天都有专业的人工客服提供技术支持，保障您的售前售后权益。',
        home38: '精选',
        home39: '全球所有热门国家/地区', 
        home40: '覆盖40+国家，极速畅享全球互联网，服务器不断扩充中！', 
 
        
 
        footer10: '绝尘致力于带给您如同本地网络般的体验, ',
        footer11: '绝尘加速',
        footer12: '关于我们',
        footer13: '隐私政策',
        footer14: '服务条款',
        footer15: '我们的服务',
        footer16: '人工客服',
        footer17: '使用帮助',
        footer18: 'IP 查询',
        footer19: '商业合作',
        footer20: '我们的邮箱',
        footer21: 'juechenvpn@gmail.com',
        footer22: '绝尘加速. All rights reserved',
        footer23: '您好！很高兴为您服务',
        footer24: '回到顶部', 
        footer25: '更多定制服务正在研发中，敬请期待',
        footer26: '客服时间：12:00-23:59',
 
 
        windows10: '绝尘帮助中心',
        windows11: 'Windows下载失败？',
        windows12: '原因：因该类软件的行业特殊性，下载时可能会遇到各种阻碍。',
        windows13: '如下载遇到问题，请参考以下解决方法（也可以在12:00-23:59期间点击右侧的客服图标联系客服）：',
        windows14: '问题类型：',
        windows15: '浏览器拦截',
        windows16: '安装包/压缩包被删',
        windows17: '软件被删',
        windows18: '第 1 步：点击 <span class="bold">“保留”</span> 后 <span class="bold">“显示详细信息</span>”<br>',
        windows19: '第 2 步：点击 <span class="bold">”仍然保留”</span><br>', 
        windows20: '第 1 步：打开电脑 <span class="bold">设置 --> 更新与安全 --> Windows安全中心 --> 病毒和威胁防护 --></span>  请看第2步<br>',
        windows21: '第 2 步：进入 <span class="bold">病毒和威胁防护 --> 管理设置</span><br>', 
        windows22: '第 3 步：进入 <span class="bold">“病毒和威胁防护”设置 --> 关闭实时保护 --></span> 如果不想关闭，请参考第四步<br>',
        windows23: '第 4 步：同样是在 <span class="bold">“病毒和威胁防护”设置</span> 页--> 滚动鼠标下滑找到 <span class="bold">排除项</span> --> 点击<span class="bold">“添加或删除排除项”</span>--> 点击弹窗中的<span class="bold">“是“</span>  <br>', 
        windows24: '第 5 步：点击 <span class="bold">“添加排除项”设置</span> 页--> <span class="bold">文件夹</span> --> 找到绝尘加速器的文件夹  --> 点击该文件夹  --> 在右下角点击<span class="bold">“选择文件夹”</span> --> 这样就完成了，可以使用加速器了。  <br>', 
        windows25: '第 1 步：打开电脑 <span class="bold">设置 --> 更新与安全 --> Windows安全中心 --> 病毒和威胁防护 --></span> 请看第2步   <br>', 
        windows26: '第 2 步：进入 <span class="bold">病毒和威胁防护 --> 保护历史记录</span>，在检查出威胁栏目里，找到“绝尘加速器”，选择恢复即可。（由于不同的系统版本，设置方法略有差异，如需帮助请点击右侧客服图标）  <br>', 

      
        android10: '绝尘帮助中心',
        android11: '安卓端安装失败？',
        android12: '原因：因该类软件的行业特殊性，下载/安装时可能会遇到各种阻碍。',
        android13: '如下载遇到问题，请参考以下解决方法（也可以在12:00-23:59期间点击右侧的客服图标联系客服）：',
        android14: '手机品牌：',
        android15: '华为/荣耀',
        android16: '小米/红米',
        android17: 'VIVO',
        android18: 'OPPO',
        android19: '一加',
        android20: '第 1 步：打开手机 <span class="bold">设置 --> 安全</span> --> 请看第2步 <br>',
        android21: '第 2 步：打开 <span class="bold">更多安全设置 --> 安装外部来源应用</span> --> 找到当前使用的浏览器给予相关安装权限（如uc浏览器） <br>',
        android22: '第 1 步：打开手机 <span class="bold">设置 --> 隐私保护</span> --> 请看第2步 <br>',
        android23: '第 2 步：点击“<span class="bold">管理</span>” <br>',
        android24: '第 3 步：点击“<span class="bold">特殊应用权限</span>” <br>',
        android25: '第 4 步：点击“<span class="bold">安装未知应用</span>” <br>',
        android26: '第 5 步：找到当前使用的浏览器给予相关安装权限（如Google浏览器） <br>',
        android27: '第 1 步：打开手机 <span class="bold">设置 --> 应用与权限</span> --> 请看第2步 <br>',
        android28: '第 2 步：点击“<span class="bold">权限</span>” <br>',
        android29: '第 3 步：点击“<span class="bold">安装未知应用</span>” <br>',
        android30: '第 4 步：找到当前使用的浏览器给予相关安装权限（如google浏览器） <br>',
        android31: '第 1 步：打开手机 <span class="bold">设置 --> 安全</span> --> 请看第2步 <br>',
        android32: '第 2 步：点击“<span class="bold">安装外部来源应用</span>” <br>',
        android33: '第 3 步：点击“<span class="bold">安装外部来源应用</span>”找到当前使用的浏览器给予相关安装权限（如google浏览器） <br>',
        android34: '第 1 步：打开手机 <span class="bold">设置 --> 应用和通知</span> <br>',
        android35: '第 2 步：点击“<span class="bold">特殊应用权限</span>” <br>',
        android36: '第 3 步：点击“<span class="bold">安装未知应用</span>” <br>',
        android37: '第 4 步：找到当前使用的浏览器给予相关安装权限（如google浏览器） <br>',


       /*   <span class="bold"></span>  */
       ios10: '绝尘帮助中心',
       ios11: 'iOS/Mac下载教程',
       ios12: '原因：因该类软件的行业特殊性，大陆暂时不支持上架。',
       ios13: '下载请参考以下解决方法（也可以在12:00-23:59期间点击右侧的客服图标联系客服）：',
       ios14: '请选择符合您的情形',
       ios15: '我有境外的苹果ID',
       ios16: '我只有大陆的苹果ID',
       ios17: '第 1 步：打开手机 <span class="bold">App Store</span> <br>',
       ios18: '第 2 步：如当前登录的是大陆ID，请点击“<span class="bold">头像</span>”icon。如已登录境外ID，请直接看第5步。 <br>',
       ios19: '第 3 步：点击头像后进入“账户” <br>',
       ios20: '第 4 步：滑至底部，点击“<span class="bold">登出</span>”--> 然后登录您的境外ID就好 <br>',
       ios21: '第 5 步：点击按钮跳转商城，或直接在商城搜索“绝尘加速器“或者”绝尘加速器官网” <br>',
       // collapse titles 
       ios22: '创建专属的境外苹果ID',
       ios23: '推荐',
       ios24: '自己的专属ID更安全，更方便',
       ios25: '点击展开教程',// down
       ios25up: '点击收起教程',// up
       ios26: '修改你的苹果ID地区',
       ios27: '在已有的苹果ID修改地区即可安装',//
       ios28: '使用共享的境外苹果ID',
       ios29: '谨记不要在设置里登录，请在App Store登录', 
       // 
       ios30: '第 1 步：前往<a href="https://appleid.apple.com/account" target="_blank">苹果官网ID注册页</a> --> 填写“ <span class="bold">姓名、国家或地区、邮箱、密码、手机号码</span>”即可 <br>',
       ios31: '第 2 步：<span class="bold">验证邮箱/手机号 </span>-->验证成功后请看下一步 <br>',
       ios32: '第 3 步：<span class="bold">添加付款方式</span>（从美国地址生成器把内容复制粘贴就行，前往<span class="bold"><a href="https://www.meiguodizhi.com/" target="_blank">美国地址生成器</a></span>） <br>',
       ios33: '第 4 步：打开“App Store”  <br>',
       ios34: '第 5 步：如当前登录的是大陆ID，请点击“<span class="bold">头像</span>”图标（ 如未登录请直接登录刚注册的ID） <br>',
       ios35: '第 6 步：进入“账户”后，滑至底部，点击“<span class="bold">登出</span>”，然后登录刚注册的ID <br>',
       ios36: '第 7 步：登录成功后，搜索“<span class="bold">绝尘加速器”或者“JCVPN”</span>，下载即可畅游全球 <br>',

       ios37: '前往苹果官方教程',
       ios38: '联系客服获取',

       windows11_1:'Windows 11连接之后没网解决办法?',
       windows11_2: '设备:',
       windows11_3: '电脑',
       windows11_4: '系统:',
       windows11_5: 'Windows 11',
       windows11_6: '版本号:',
       windows11_7: '24H2',
       windows11_8: '问题:',
       windows11_9: '连接没网',
       windows11_10: '首先，点击Windows图标，然后点击【设置】',
       windows11_11: '接下来点击左边的【系统】',
       windows11_12: '第四步将鼠标放到右边，下拉到最后，点击【可选功能】',
       windows11_13: ' 第五步，同样下拉到最后，点击【更多Windows功能】',
       windows11_14: ' 在弹出的窗口，找到【Virtual Machine Platform】',
       windows11_15: '然后点击【Virtual Machine Platform】前面的小方框，将其勾选上就完成了',
       windows11_16: '最后，将电脑重启，重新打开软件就可以正常使用了',


       client_windows:"下载客户端",
       client_android:"下载Android端",
       client_ios:"下载iOS端",
       client_mac:"下载Mac端",
       client_linux:"Linux", 

       payment_success1:"充值绝尘币",
       payment_success2:"复制",
       payment_success3:"支付成功!",
       payment_success4:"感谢您的购买！如遇问题，请联系客服~",
       payment_success5:"订单号",
       payment_success6:"已复制订单号", 
       payment_success7:"订单号未复制",

 
        privacy1:  '绝尘加速器（以下简称绝尘）通过在连接到Internet时建立安全的虚拟专用网络，将服务作为保护您隐私的一种手段。<br>',
        privacy2:  '绝尘尊重并保护所有使用绝尘网络服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务,绝尘会按照本隐私政策的规定使用和披露您的个人信息，但绝尘将以高度的勤勉、审慎义务对待这些信息。<br>',
        privacy3:  '除本隐私权政策另有规定外,在未征得您事先许可的情况下,绝尘不会将这些信息对外披露或向第三方提供。绝尘会不时更新本隐私权政策。您在同意绝尘络服务使用协议之时,即视为您已经同意本隐私权政策全部内容。本隐私权政策属于绝尘网络服务使用协议不可分割的一部分。',
        privacy4:  '1. 用户数据收集',
        privacy5:  '我们确保永远不会记录用户的浏览历史记录，访问的数据内容，以及DNS查询。因此：',
        privacy6:  '我们不知道哪个用户曾经访问过特定的网站或服务。',
        privacy7:  '我们不知道哪个用户在特定时间连接了加速器以及使用了哪个加速器服务器的IP地址。',
        privacy8:  '我们不知道用户计算机或者移动设备的原始IP地址。',
        privacy9:  '如果有人需要我们提供上述用户信息，我们将无法提供，因为数据不存在。',
        privacy10: '手机号和邮箱',
        privacy11: '我们后期在用户注册时，可能会选择性让用户绑定手机号和邮箱（选填），我们收集用户绑定的手机号或者邮箱，用于帮助用户找回账号密码，以及在反馈问题后及时收到我们的回复。',
        privacy12: '设备型号和系统版本',
        privacy13: '我们收集用户的设备型号和系统版本，用来统计哪些型号的设备或者操作系统，连接VPN后不太好用，便于我们针对性的调试和解决问题。',
        privacy14: '2. 信息使用',
        privacy15: 'a) 绝尘不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息,除非事先得到您的许可',
        privacy16: 'b) 绝尘亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何绝尘平台用户如从事上述活动,一经发现,绝尘有权立即终止与该用户的服务协议。',
        privacy17: 'c) 为服务用户的目的,绝尘可能通过使用您的个人信息,向您提供您感兴趣的信息,包括但不限于通过邮件或者短信等向您发出产品和服务信息。',
        privacy18: '3. 信息披露',
        privacy19: '在如下情况下,绝尘将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息:',
        privacy20: 'a) 经您事先同意,向第三方披露;',
        privacy21: 'b) 为提供您所要求的产品和服务,而必须和第三方分享您的个人信息;',
        privacy22: 'c) 根据法律的有关规定,或者行政或司法机构的要求,向第三方或者行政、司法机构披露;',
        privacy23: 'd) 如您出现违反所在国家地区的有关法律、法规或者绝尘服务协议或相关规则的情况,需要向第三方披露;',
        privacy24: 'e) 其它绝尘根据法律、法规或者网站政策认为合适的披露。',
        privacy25: '4. 信息安全',
        privacy26: 'a) 绝尘帐号均有安全保护功能,请妥善保管您的用户名及密码信息。绝尘将通过对用户密码进行加密等安全措施确保您的信息不丢失,不被滥用和变造。尽管有前述安全措施,但同时也请您注意在信息网络上不存在“完善的安全措施”。',
        privacy27: 'b) 如您发现自己的个人信息泄密,尤其是绝尘用户名及密码发生泄露,请您立即联络绝尘客服,以便绝尘采取相应措施。',
        privacy28: '5.改变',
        privacy29: 'a)我们保留自行决定随时修改或替换这些条款的权利。在这些修订生效后继续访问或使用我们的服务，您同意受修订条款的约束。如果您不同意新条款，请停止使用本服务。',
        privacy30: '我们可能随时和不时更改我们的条款。最新版本的条款反映在本协议顶部的版本日期。所有更新和修订在更新后立即生效。我们建议您经常查看我们的条款，以便随时了解可能对您产生的影响，因为您继续使用该申请表示您继续同意接受我们的条款约束。',
        privacy31: 'b)我们可以出于任何原因立即终止或暂停访问我们的服务，恕不另行通知或承担任何责任，包括但不限于您违反本条款。本条款的所有条款本质上应在终止后继续有效，包括但不限于所有权条款，保证免责声明，赔偿和责任限制。',
        privacy32: '6.适用法律',
        privacy33: '这些条款应受所在国家地区的法律管辖和解释，而不考虑其法律冲突规定。',
        privacy34: '我们未能执行这些条款的任何权利或规定将不被视为放弃这些权利。如果这些条款的任何条款被法院认定为无效或不可执行，则这些条款的其余条款将继续有效。这些条款构成我们之间关于我们服务的完整协议，并取代我们之间可能拥有的有关服务的任何先前协议。',

        terms1:  '一般的',
        terms2:  '我们的目标是为所有客户提供优质服务。在您访问本网站或服务之前，请仔细阅读这些服务条款。',
        terms3:  '本服务条款（以下简称“本条款”）约束您对 绝尘加速器 及其相关网站域名（以下简称“网站”）和相关服务（以下简称“服务”）的使用，这些服务由 绝尘加速器 团队（以下简称“绝尘”、“我们的”、“我们”）拥有和运营。本条款构成您与 绝尘 团队之间具有法律约束力的协议（以下简称“协议”）。',
        
        terms4:  '绝尘加速器 服务',
        terms5:  '您了解我们为您提供虚拟专用网络（或“加速器”）服务，包括但不限于使用服务器、传输、路由器、IP 地址和其他设备和协议通过我们的网络（“系统”）传输信息。您同意遵守有关您使用服务的条款。',
        
        terms6:  '使用政策',
        terms7:  '通过使用 绝尘加速器 服务（“服务”），您同意：',
        terms8:  'a) 不得使用该系统发送垃圾邮件、端口扫描、扫描开放代理或开放中继、发送选择加入电子邮件、未经请求的电子邮件或任何类型或版本大量发送的电子邮件，即使该电子邮件最终是从另一台服务器发送的。',
        terms9:  'b) 不要从我们的服务启动任何弹出窗口。',
        terms10: 'c) 在使用我们服务时不得以任何方式攻击任何其他计算机或网络。',
        terms11: 'd) 不得使用该服务进行可能损害我们的网络或其他人的事情。',
        terms12: 'e) 用户有责任了解并理解与您和您的行为有关的任何司法管辖区或地点的所有相关法律。绝尘加速器 不以任何方式或形式对其用户的行为负责，包括刑事责任和对造成或未造成的损害的民事责任，超出具体个人向 绝尘加速器 支付的任何服务费用。',
        terms13: 'f) 违反本使用政策或条款可能会导致您的帐户被终止，并且不会退还之前为服务支付的任何金额。此外，您可能要对 绝尘 遭受的任何和所有损失负责，包括由于上述违规行为而由任何外部实体收取的任何金额，包括但不限于律师费和费用。',
        terms14: 'g) 绝尘加速器 可让您将软件、软件更新或补丁或其他实用程序和工具下载到您的手机或支持互联网的设备上。绝尘加速器（“软件”）授予您非独占的有限许可，仅允许您根据本条款将软件用于 绝尘加速器 在向您提供软件时所述的目的。严禁修改、分发给未经授权的各方、进行逆向工程或以任何未经 绝尘加速器 明确授权的方式使用软件。',
        
        terms15: '免责声明',
        terms16: 'a) 我们努力防止网站和服务中断。但是，这些内容是按“原样”和“可用”提供的，并且我们不以明示或暗示的方式保证通过网站或服务提供的任何材料或信息的准确性，也不保证其适用于任何特定用途。',
        terms17: 'b) 实际服务覆盖范围、速度、位置和质量可能有所不同。除维护和维修的有限时间外，服务将尝试随时可用。但是，服务可能会因我们无法控制的各种因素而不可用，包括紧急情况、第三方服务故障、传输、设备或网络问题或限制、干扰、信号强度，并且可能会中断、拒绝、限制或缩减。',
        terms18: 'c) 我们不保证服务将满足您的要求，也不保证服务不会中断、及时、安全或无错误，也不保证缺陷（如有）将得到纠正。您承认，您访问网站和服务完全出于您的判断并由您自行承担风险。',
        terms19: 'd) 对于因服务或通信服务或网络（例如 T-1 线路或互联网）中断或性能问题而导致的数据、消息或页面丢失、未送达、延迟或误传，我们概不负责。我们可自行决定限制使用量或服务、暂停服务或阻止某些类型的使用，以保护用户或服务。网络速度是估算值，并不表示您或服务发送或接收数据的速度。实际网络速度将根据配置、压缩、网络拥塞和其他因素而有所不同。我们无法保证所接收数据的准确性和及时性；可能会出现延迟或遗漏。',
        terms20: 'e) 我们不记录任何用户活动（访问的网站、DNS 查询、电子邮件等）。我们仅记录对我们服务器的访问尝试，以用于故障排除和改进服务。我们不参与任何形式的审查。我们不会将您的个人信息提供给任何第三方。',
        
        terms21: '条款变更',
        terms22: 'a) 绝尘加速器 可能会不时更新本条款，恕不另行通知。本条款的任何变更都将纳入修订后的协议，我们将在网站上发布该协议。除非另有规定，否则此类变更自发布之日起生效。如果我们对这些条款做出重大变更，我们将通过应用程序或在您查看我们的网站时通知您。',
        
        terms23: '最后',
        terms24: 'a) 绝尘加速器 深信消费者隐私、安全和网络自由，我们以此管理和保护消费者隐私和个人信息。如果您有任何问题或疑问，我们都会通过电子邮件地址<br>juechenvpn@gmail.com为您提供支持',
        



        home: '首页', 
        support:'使用帮助',
        contactus:'在线咨询',
        settings: '设置',
        change_locale: '改变区域',
        dashboard: '控制面板',
        login_username: '登录_用户名',
        login_password: '登录_密码',
        submit: '提交',
        logout: '退出账户', 
        add_new_user: '添加新用户',
        username: '用户名',
        password: '密码', 
        email: '邮箱',
        phone: '电话',
        activate: 'Activate',
        validity: 'Validity',
        active: '活跃的',
        inactive: '不活跃的',
        awaiting: 'Awaiting', 
        traffic_done: 'Traffic Done',
        status: '地位',
        display: 'Display',  
        permission: '权限',
        date_created: '创建日期',
        action: '行动', 
        increase: '增加',
        decrease: 'Decrease',
        add: '添加',
        edit: '编辑',
        delete: '删除',
        go_back: '返回',
        select: '选择',  
        name: "名称",
        key: "钥匙", 
        bandwidth: 'Bandwidth',
        extra_bandwidth: 'Extra Bandwidth',
        bandwidth_high: 'Bandwidth High limit(GB)',
        bandwidth_low: 'Bandwidth Low limit(GB)',
        bhigh: 'High',
        blow: 'Low', 
        confirm_delete: '确定删除', 
        save:'Save',
        billed: '计费',
        not_listed: 'Not Listed',
        sorting_order: '序号',
        description: '描述',
        monthly: '每月的',
        weekly: 'Weekly',
        quarterly: 'Quarterly',
        biannual: 'Biannual',
        yearly: '每年的',
        manually: '手动',
        title: '标题',
        for: "为了",
        all: "全部", 
        android: "Android", 
        ios: "IOS",
        languages: "语言",
        price: '价格',
        coins: 'Coins',
        extra_coins: 'Extra Coins',
        is_basic_plan: 'Basic Plan',
        discount: '折扣',
        rate:'Rate',
        currencies: "货币",
        detail: '明细',
        speed_limit: '限速',
        manage: '管理',
        payment: '支付',
        methods: '方法',
        mode: '模式',
        live: '线上',
        data: '数据',
        icon: '图标',
        code: '代码',
        channels: '渠道',
        groups: '团体',
        group: '团体',
        remark: '备注',
        info: '信息',
        assign: '分配',
        to: '至',
        method: '方法',
        shortcuts: '快捷方式',
        link: '链接',
        view: '浏览',
        list: '列表',
        users: '用户',
        user: '用户',
        search: '搜索',
        servers: '服务器',
        areas: '地区',
        types: '类型', 
        lists: 'Lists',
        information:'Information',
        main: 'Main',
        multiple:'Multiple',
        port: 'Port',
        ports: 'Ports',
        total: '合计',
        clients: '客户端',
        none: 'Not Selected',
        announcements: '公告',
        created: '已创建',
        expired: '已到期',
        at: '在',
        url: '网址',
        yes: '是',
        no: '否',
        base_currency: '基础货币',
        config: '配置', 
        configuration: 'Configuration',
        order: '命令',
        orders: '订单',
        number: '数字',
        amount: '金额',
        package: '套餐',
        paid: '已支付',
        un_paid: '未支付',
        started: '已启动',
        completed: '完成的',
        pending: '待定',
        cancelled: '取消的',
        rejected: '被拒绝的',
        refund: '退款',
        default: '默认',
        allowed: '允许',
        devices: '设备',
        additonal: '附加的',
        version: '版本',
        version_old: '老版本',
        sha256: 'sha256',
        pack_size: '包装大小',
        force: '强制',
        type: '类型',
        force_type_zero: '用户选择更新',
        force_type_one: '强制全部更新l',
        currency: '货币',

        apply: '申请', 
        reset: '重置',
        close: '关',
        plan_time: '计划时间',
        minutes: '分钟', 
        days:"Days",
        packages: '套餐',
        start: '开始',
        end: '结尾',
        date: '日期',
        free: '自由',
        premium: '高级套餐‘',
        both: '双方',
        transfer: '转移',
        id: 'ID',
        url_config: '网址配置',
        value: '价值',
        extra: '额外的',

        online: '在线的',
        today: '今天',
        new: '新的',
        not: '不是',
        confirmed: '确认的',
        trial: '审判',
        reward: '报酬',
        login: '登录',
        level: '等级',
        language: '语',
        invite: '邀请',
        referrer: '推荐人',
        faq: 'FAQ',
        question: '题',
        answer: '回答',

        blog: '博客',
        slug: '蛞蝓',
        viewed: '看过',
        image: '图片',
        meta: '元',
        text: '文本',
        optional: '可选的',
        keywords: '关键词',
        welcome: '欢迎',
        console: '安慰',
        author: '作者',
        category: '类别', 
        categories: 'Categories',
        months: '月',
        recommended: '推荐',
        news: '消息',
        ticket: 'Tickets',
        subject: 'Subject',
        resolved: 'Resolved',
        replied: 'Replied',
        spam: 'Spam',
        reply: 'Reply',
        message: 'Message',
        messages: 'Messages',
        admin:'Admin',
        admin_operation_logs: 'Admin Operation Logs',
        restricted: 'Restricted',
        area: 'Area',
        reports: 'Reports',
        registered: 'Registered',
        last_7_days: 'Last 7 days',
        last_30_days: 'Last 30 days',
        last_90_days: 'Last 90 days',
        last_365_days: 'Last 1 year',
        last_2_years_days: 'Last 2 Years',
        last_3_years_days: 'Last 3 Years',
        days_count:' Days Count',
        _1_days: ' 1 Days',
        _3_days: ' 3 Days',
        _7_days: '7 Days',
        _30_days: '30 Days',
        _90_days: '90 Days',
        _180_days: '180 Days',
        _1_years_days: '1 year (360 Days) ',
        _2_years_days: '2 Years (730 Days)',
        _3_years_days: '3 Years (1095 Days)',
        client: 'Client',
        tutorial: 'Tutorial',
        paying: 'Paying',
        other: 'other',
        yesterday: 'Yesterday',
        custom_date_filter: 'Custom date',
        vpn: 'VPN',
        lattitude: 'lattitude',
        longitude: 'longitude',
        max_network_bandwidth: 'Max network bandwidth',
        network_bandwidth: 'Network bandwidth',
        load: 'load',
        mid: 'MID',
        hourly: 'Hourly',
        udid: 'udid',
        token: 'Token',
        first: 'First',
        time: 'Time',
        bugs: 'Bugs',
        refresh: 'Refresh',
        user_id: 'User ID',
        node_id: 'Node',
        log_detail: 'Log Detail',
        device_detail: 'Device Detail',
        client_id: 'Client_ID',
        unique_no: 'Unique No',
        clients_error: 'Errors',
        renewals: 'Renewals',
        download: 'download',
        last_active_time: 'Last active time',
        temp: 'Temp',
        offer: 'offer',
        push_notification: 'Push Notification',
        send: 'Send',
        device: 'Device',
        whitelist: 'Whitelist',
        points: 'Points',
        total_points: 'Total Points',
        deep_link: 'Deep Link',
        is_offer: 'Is Offer',
        is_disabled: 'Is Disabled',
        gift_code_builder: 'Gift Code Builder',
        batch: 'Batch',
        count: 'Count',
        purpose: 'Purpose',
        plan: 'Plan',
        plans: 'Plans',
        generated_by: 'Generated By',
        receive_money: 'Receive Money',
        finance_comment: 'Finance comment',
        gift_codes: 'Gift Codes',
        cancel: 'Cancel',
        generate: 'Generate',
        btach_name: 'Batch Name',
        sr_no: 'SR.NO',
        card_code: 'Card-Code',
        redeem_status: 'Redeem Status',
        used_time: 'Used Time',
        used: 'Used',
        demo: 'Preview', 
        refer_friend:"Refer Friend",
        verify_email: "Verify Email", 
        by: "by",  
        last: "Last", 
        preffered_language: "Preffered language",
        preffered_theme: "Preffered theme",
        guest_user: "Guest user", 
        verification_code: "Verification Code",
        refferal_id: "Refferal ID",
        order_history: "Order history",
        packages_history: "Packages history",
        order_not_find:"No Orders found",
        packages_not_find:"No packages found",
        earn_points_not_found:"No Earn points found",
        redeem_points_not_found: "No Redeem Points found",
        devices_not_found: "Devices not found",
        tickets_not_found: "Tickets not found",
        lookup: "Lookup",
        transaction_id: "Transaction ID",
        check: "Check",
        allowed_countries: "Allowed Countries",
        guest: "Guest",
        redeem: "Redeem",
        account: "Account",
        current: "Current",
        change_password_heading: "Please change your password",
        country: 'Country',  
        domains: 'Domains',
        domain: 'Domain',
        weight: 'Weight', 
        protocol:'Protocol',
        available:"Available",
        
        order_number_not_found:"Order not found with this order number.",
        order_username_different:"Order username not matched with given username.",
        package_not_found:"Package not found.", 
        balance:"Balance", 
        in:"In",
        out:"Out",
        deleted:"Deleted",


        share_1: "分享",
        share_2:"邀新人，返佣高达",
        share_3:"扫描下载客户端",
        share_4:"无法打开？请使用非系统浏览器扫描",
        share_5:"我的邀请码",
        share_6: "链接邀请",
        share_7: "图片保存",
        share_8: "近半年邀请(人)",
        share_9: "累计返佣(元)",
        share_10: "分享奖励",
        share_11: "赠送XX积分",
        share_12: "下级用户成功填写您的邀请码，系统立即自动赠送积分，积分可兑换套餐。",
        share_13: "充值返佣，最高达",
        share_14: "下级用户本人及TA的下两级用户充值，您将获得返佣。",
        share_15: "佣金以积分形式下发，佣金积分可提现。",
        share_16: "用户等级",
        share_17: "首充",
        share_18: "续费",
        share_19: "一级",
        share_20: "二级",
        share_21: "三级",
        share_22: "什么是一、二、三级用户？",
        share_23: "严禁盗刷，系统一旦检测到将删除奖励或封号",
        share_24: "最终解释权归【绝尘加速器】所有",
        share_25: "复制成功",
        share_26: "图片下载中，请稍候...",


        dialog_share_tips_1: "复制成功",
        dialog_share_tips_2: "如您的好友无法打开分享链接，请好友使用非系统浏览器打开。",
        dialog_share_tips_3: "知道了",


        referral_rewards_title: "下级用户及佣金比例",
        referral_rewards_des: "您的下级用户定义及您可获得的佣金比例",
        referral_rewards_card_1: "您本人",
        referral_rewards_card_2: "新用户A",
        referral_rewards_card_3: "新用户B",
        referral_rewards_card_4: "新用户C",
        referral_rewards_level_1: "一级用户",
        referral_rewards_level_2: "二级用户",
        referral_rewards_level_3: "三级用户",
        referral_rewards_label_1: "您分享",
        referral_rewards_label_2: "A分享",
        referral_rewards_label_3: "B分享",
        referral_rewards_label_4: "首",
        referral_rewards_label_5: "充",
        referral_rewards_label_6: "续",
        referral_rewards_label_7: "费",
        referral_rewards_label_br: "block",
        referral_rewards_definition_show: "none",
        referral_rewards_definition: "",


        share_link_1: '绝尘加速器',
        share_link_2: '无阻碍畅游全球所有平台',
        share_link_3: '您的正在好友邀下载“绝尘加速器”',
        share_link_4: '您的好友邀请码',
        share_link_5: '永久免费 无套路 顶尖技术团队打造',
        share_link_6: '不限速',
        share_link_7: '隐藏您真实IP',
        share_link_8: '无痕安全连接',
        share_link_9: '安卓/鸿蒙下载',
        share_link_10: '前往官网下载更多',
        share_link_11: '官方联系地址',
        share_link_12: '绝尘官网',
        share_link_13: '（如无法打开，请翻墙后打开）',
        share_link_14: 'juechenjsq.co',
        share_link_15: '绝尘TG用户群',
        share_link_16: '（需翻墙）',
        share_link_17: 'https://t.me/juechenvpn1',
        share_link_18: '在线客服',
        share_link_19: '（12:00-23:59）',
        share_link_21: '官方邮箱',
        share_link_22: '（商务合作/联系客服）',
        share_link_23: 'juechenvpn@gmail.com',
        share_link_24: '如打开失败，请连接VPN后重试',
        

        share_image_part_1: '扫码下载客户端 畅游全网',
        share_image_part_2: '无法打开？请使用非系统浏览器扫描',


        points_details_1: '积分明细',
        points_details_2: '佣金积分有10天锁定期，10天后计入可用积分，该积分可提现',
        points_details_3: '积分明细',
        points_details_4: '没有记录',
        points_details_5: '累计返佣',
        points_details_btn_arr : ['全部', '已计入', '待计入', '已使用', '退款/扣除','已添加','提现成功','已扣除','已退款'],
        invitation_reward: '邀请奖励',
        points_details_filter_arr: ['最近三个月', '最近六个月', '最近一年', '最近两年'],
        

        purchase_level_1: '一级用户购买',
        purchase_level_2: '二级用户购买',
        purchase_level_3: '三级用户购买',
        renwal_level_1: '一级用户续费',
        renwal_level_2: '二级用户续费',
        renwal_level_3: '三级用户续费',
        deducted_level_1: '一级用户退款',
        deducted_level_2: '二级用户退款',
        deducted_level_3: '三级用户退款',   
        share_earned: '邀请新用户',
        redeem_package: '兑换流量包',
        withdraw: '提现',
        test_points: '其它',




        my_points_1: '我的积分',
        my_points_2: '可用积分',
        my_points_3: '包括可提现积分',
        my_points_4: '提现',
        my_points_5: '待计入(积分)',
        my_points_6: '累计奖励',
        my_points_7: '任务中心',
        my_points_8: '分享赚现金',
        my_points_9: '佣金',
        my_points_10: '邀请新用户赚佣金',
        my_points_11: '去分享',
        my_points_12: '积分换好礼',
        my_points_13: '暂无可兑换好礼，敬请期待~',
        my_points_14: '天',
        my_points_15: '积分',
        my_points_16: '小时',
        my_points_17: '分钟',
        my_points_18: '成功兑换',
        my_points_19: '已成功兑换套餐',
        my_points_20: '兑换失败',
        my_points_21: '可用积分不足以兑换套餐',
        my_points_22: '兑换流量包',
        my_points_23: '消耗',
        my_points_24: '积分',
        my_points_25: '兑换',
        my_points_26: '取消',
        my_points_27: '流量包',
        my_points_28: '兑换',
        my_points_29: '流量包归属',
        my_points_30: '更改',
        my_points_31: '请输入用户名',
        my_points_32: '用户名长度为5-16位',
        my_points_33: "用户名不正确或不存在",
        my_points_34: "确认兑换信息",
        my_points_35: "确定",
        my_points_36: "兑换成功",
        my_points_37: "套餐已兑换成功，可回到个人中心查看",
        my_points_38: "知道了",
        my_points_39: "可用积分",
        my_points_40: "，无法兑换",
        my_points_41: "",


        withdraw_1: "提现",
        withdraw_2: "提现记录",
        withdraw_3: "可提现(元)",
        withdraw_4: "累计提现(元)",
        withdraw_5: "积分",
        withdraw_6: "转出金额",
        withdraw_7: "约等于(积分)",
        withdraw_8: "提现金额不能低于",
        withdraw_9: "不能低于100元",
        withdraw_10: "转出到",
        withdraw_11: "支付宝",
        withdraw_12: "手续费6%",
        withdraw_13: "更换",
        withdraw_14: "支付宝账户",
        withdraw_15: "请输入支付宝账户",
        withdraw_16: "真实姓名",
        withdraw_17: "用于转账验证",
        withdraw_18: "预计7个工作日处理完成",
        withdraw_19: "提交",
        withdraw_20: "汇率按转账当天交易所实时汇率",
        withdraw_21: "USDT地址",
        withdraw_22: "请输入USDT地址",
        withdraw_23: "选择收款方式",
        withdraw_24: "取消",
        withdraw_25: "不允许使用特殊字符（例如 @、&、_、^、.）和字母。请输入数字",
        withdraw_26: "可提现金额不足",
        withdraw_27: "提现金额不能低于100",
        withdraw_28: "确认信息",
        withdraw_29: "提现金额",
        withdraw_30: "手续费4U",
        withdraw_31: "确认并提交",
        withdraw_32: "仅限数字英文和符号",

        withdraw_suc_1: "提现",
        withdraw_suc_2: "提交成功",
        withdraw_suc_3: "预计7个工作日处理完成",


        withdrawn_history_1: '提现记录',
        external_links_title: '热门导航',
        withdrawn_history_2: '提现',
        withdrawnStatusArr: ['处理中','提现成功','提现失败','提现取消'],


        error_share_1 : "哎呀~出错了",
        error_share_2 : "页面载入错误",
        error_share_3 : "返回首页",

        defaultFeatureName: '敬请期待',
        defaultMessage: '这是一条任意内容',
        defaultFeatureCatiguryName:'我是个功能',
        cat_1:'热门',
        cat_2:'类目 1',
        cat_3:'类目 2',
        cat_4:'类目 3',
        cat_5:'类目 4',
        cat_6:'类目 5',
        cat_7:'类目 6',
        recent_msg_title: '今日热点',

        title_section_1: '本月奖励',
        months_rewards: '7月1日-7月31日',
        reward_records_btn: '奖励记录>',
        sp1: '邀请新用户，最高奖',
        sp2: '70天套餐+积分+',
        sp2_com: '%返佣',
        invint_note: '系统检测为有效用户后，立即计入有效邀请',
        people: '人',
        invites: '人',
        orange_label: '送20天40GB',
        title_section_2: '本月福利',
        title_note_2: '可选套餐或积分',

        list_gifts_title1: '充值返佣，高达',
        list_gifts_des11: '新用户填写邀请码后，可获得其首充订单金额的',
        list_gifts_des11_com: '%作为返利。',
        list_gifts_des12: '以积分方式发放，可提取或兑换套餐',
        to_invite: '去邀请',
        get_rewards: '领取奖励',
        received: '已领取',
        share_link_55: '邀请新用户，壕礼送不停',
        share_title: '邀新人',
        rewards_rules:'奖励规则',
        item_sec3_1: '填邀请码(人)',
        item_sec3_2: '有效邀请(人)',
        item_sec3_3: '普通积分',
        item_sec3_4: '佣金积分',
        rewards_dialog_title: '奖励记录',
        note_rewards_dialog: '积分计入积分中心，套餐计入个人中心套餐列表',
        apply_gift_dialog_des:'恭喜您完成挑战，请选择领取套餐或积分',
        or:'或',
        apply_package:'领取套餐',
        apply_points:'领取积分',
        apply_p:'积分',
        suc_title_gift_dialog: '领取成功',
        suc_des_gift_dialog: '您的奖励已领取成功',
        des_extra_points_1: '本月超',
        des_extra_points_2: '位后，每邀1人得',
        des_extra_points_3: '积分，次月1号系统自动发放',
        current_points_b1: '待发放',
        current_points_b2: '积分',
        reward_rules_1: '邀请任务奖励',
        reward_rules_2: '成功邀请',
        reward_rules_3: '有效新用户',
        reward_rules_4: '，可完成阶段任务并领取奖励；',
        reward_rules_5: '奖励：',
        reward_rules_6: '普通积分 / 套餐权益（二选一），普通积分可用于兑换套餐。',
        reward_rules_7: '有效用户：',
        reward_rules_8: '需填写邀请码并达成系统判定标准',
        reward_rules_9: '未达标的不计入任务进度',
        reward_rules_10: '发放说明',
        reward_rules_11: '完成任务后可随时领取',
        reward_rules_12: '若当月未领取，系统将于次月1日自动发放奖励',
        reward_rules_13: '下级用户首充奖励',
        reward_rules_14: '下级用户填写邀请码后充值，您将获得其订单金额的40%；以佣金积分方式发放；',
        reward_rules_15: '若对方',
        reward_rules_16: '先充值后填写邀请码',
        reward_rules_17: '，不计入奖励。',
        reward_rules_18: '发放说明',
        reward_rules_19: '购买后立即自动发放，有10天锁定期；',
        reward_rules_20: '解锁后佣金积分可用于提现或兑换套餐。',
        reward_rules_21: '严禁盗刷，系统一旦检测到将删除奖励或封禁',
        dialog_save_img_tips_1: '成功',
        dialog_save_img_tips_2: '图像保存成功',
        dialog_save_img_tips_3: '保存失败',
        dialog_save_img_tips_4: '如重试后仍失败，可更新软件解决',
        claim_faild:'领取失败，请重试',
        defaultUserSubmission: '用户名',
        defaultTextSubmission: '描述',
        loadingUserSubmission: '加载中...',
        loadingTextSubmission: '',
        desSubmission: '向我们描述您的内容。',
        formSubmissionTitle: '发布您的内容:',
        submittedSuccess: '提交成功',
        noSubmissions: '暂无内容.',
        publishContent: '发布内容',
        titleSubmissionsPage: '发布网址/应用',
        submissionsIns1: '发布规则：请严格按以下格式发布，否则将视为无效。感谢您的理解与配合！',
        submissionsIns2: '1.产品名称：',
        submissionsIns3: '2.网址：',
        submissionsIns4: '3.Logo：',
        submissionsIns5: '4.简介：',
        submissionsIns6: '5.是否需要VPN才可以访问（若仅限特定地区，请备注）：',
        submissionsIns7: '6.支持的客户端：',
        submissionsIns8: '7.您的邮箱/Telegram（仅该项选填）：',
        expandedTextBtn: '收起示例',
        notExpandedTextBtn: '展开示例',
        submissionExp1: '1.产品名称：绝尘加速器',
        submissionExp2: '2.网址：www.juechenjsq.co',
        submissionExp3: "3.Logo：www.juechenjsq.co\\logo.icon",
        submissionExp4: '4.简介：是一款永久免费且不限设备数的VPN',
        submissionExp5: '5.是否需要VPN才可以访问：否',
        submissionExp6: '6.支持的客户端：安卓、iOS、Windows、Mac OS',
        submissionExp7: '7.您的邮箱/Telegram（仅该项选填）：juechenvpn@gmail.com',
        loading_more: '加载更多',
        external_links_error_page1:'热门导航',
        external_links_error_page2:'加载失败',
        external_links_error_page3:'请重试',
        external_links_error_page4:'重新加载',
        my_points_error: '我的积分',
        points_details_error: '积分明细',
        withdrawal_error: '提现',
        withdrawal_history_error: '提现记录',
        share_error: '邀新人',
        external_links_error: '热门导航',
        external_links_dialog_title: '免责声明',
        external_links_dialog_des1: '1. 本服务可能包含来自第三方的广告和内容。这些广告或内容与本服务无关，其准确性、完整性或合法性由相应的第三方负责，本服务对此不承担任何责任。',
        external_links_dialog_des2: '2. 您通过广告点击或购买第三方产品或服务所产生的任何交易与法律责任，均由您与第三方自行解决，本服务对此类交易不作任何保证，亦不承担任何责任。',
        loading_file_error: '出现了一些问题，请稍后再试',
        contentPublishingTabVisible:'yes',
        downloadAppWithJumping: 'yes',
        androidDownloadingInWindowsClient: 'no',
        deleteWindowsBtn: 'no',
        feature_title: '特征',
        feature_desc: '描述',
        feature_dialog_title: '广告赞助'
    },

    'en': {
 
        
        home10: ' 永久免费 一键加速全网',
        home11: '永久免费，适合游戏、影音、直播、办公等多种需求；不限设备数，不限速，海量专线带宽，更快更稳定更安全！',
        home12: '(免费使用)',
        home13: '更多客户端',
        home14: '全网唯一',
        home15: '不限设备数',
        home16: '的加速器',
        home17: '多设备同时登录，办公娱乐更便捷',
        home18: 'Windows',
        home19: 'Android',
        home20: 'iOS',
        home21: 'macOS',
        home22: '随时随地 畅游',
        home23: '全球所有平台',
        home24: '尽情畅享更私密、更安全的互联网，阻止网络跟踪器',
        home25: '为什么选择绝尘加速器',
        home26: '极速体验',
        home27: '真正的不限速，致力带给您 如同本地网路般的上网体验',
        home28: '不限设备数',
        home29: '下载即可使用 无需绑定账号，多设备同时在线，工作娱乐更便捷',
        home30: '极限低延迟',
        home31: '海量专线带宽，致力提供接近极限的低延迟',
        home32: '日套餐 随用随开',
        home33: '全网唯一一家敢提供日套餐，什么时候用就什么时候开，永不担心被套牢。',
        home34: '行业领先的加密技术',
        home35: '通过 256 位 AES 加密、DNS/IPv6泄漏保护和终止开关来保护您的数据和在线活动。',
        home36: '卓越的客服团队',
        home37: '365天都有专业的人工客服提供技术支持，保障您的售前售后权益。',
        home38: '精选',
        home39: '全球所有热门国家/地区', 
        home40: '覆盖40+国家，极速畅享全球互联网，服务器不断扩充中！', 
 
        
 
        footer10: '绝尘致力于带给您如同本地网络般的体验, ',
        footer11: '绝尘加速器',
        footer12: '关于我们',
        footer13: '隐私政策',
        footer14: '服务条款',
        footer15: '我们的服务',
        footer16: '人工客服',
        footer17: '使用帮助',
        footer18: 'IP 查询',
        footer19: '商业合作',
        footer20: '我们的邮箱',
        footer21: 'juechenvpn@gmail.com',
        footer22: '绝尘加速器. All rights reserved',
        footer23: '您好！很高兴为您服务',
        footer24: 'Scroll to top', 
        footer25: '更多定制服务正在研发中，敬请期待',
        footer26: '客服时间：12:00-23:59',

 
        
 
        windows10: '绝尘帮助中心',
        windows11: 'Windows下载失败？',
        windows12: '原因：因该类软件的行业特殊性，下载时可能会遇到各种阻碍。',
        windows13: '如下载遇到问题，请参考以下解决方法（也可以在12:00-23:59期间点击右侧的客服图标联系客服）：',
        windows14: '问题类型：',
        windows15: '浏览器拦截',
        windows16: '安装包/压缩包被删',
        windows17: '软件被删',
        windows18: '第 1 步：点击 “<span class="bold">保留</span>” 后 <span class="bold">“显示详细信息</span>”  <br>',
        windows19: '第 2 步：点击 ”<span class="bold">仍然保留</span>” <br>', 
        windows20: '第 1 步：打开电脑 <span class="bold">设置 --> 更新与安全 --> Windows安全中心 --> 病毒和威胁防护 --></span>  请看第2步  <br>',
        windows21: '第 2 步：进入 <span class="bold">病毒和威胁防护 --> 管理设置</span>  <br>', 
        windows22: '第 3 步：进入 <span class="bold">“病毒和威胁防护”设置 --> 关闭实时保护 --></span> 如果不想关闭，请参考第四步 <br>',
        windows23: '第 4 步：同样是在 <span class="bold">“病毒和威胁防护”设置</span> 页--> 滚动鼠标下滑找到 <span class="bold">排除项</span> --> 点击<span class="bold">“添加或删除排除项”</span>--> 点击弹窗中的<span class="bold">“是“</span>  <br>', 
        windows24: '第 5 步：点击 <span class="bold">“添加排除项”设置</span> 页--> <span class="bold">文件夹</span> --> 找到绝尘加速器的文件夹  --> 点击该文件夹  --> 在右下角点击<span class="bold">“选择文件夹”</span> --> 这样就完成了，可以使用加速器了。  <br>', 
        windows25: '第 1 步：打开电脑 <span class="bold">设置 --> 更新与安全 --> Windows安全中心 --> 病毒和威胁防护 --></span> 请看第2步   <br>', 
        windows26: '第 2 步：进入 <span class="bold">病毒和威胁防护 --> 保护历史记录</span>，在检查出威胁栏目里，找到“绝尘加速器”，选择恢复即可。（由于不同的系统版本，设置方法略有差异，如需帮助请点击右侧客服图标）  <br>', 



        android10: '绝尘帮助中心',
        android11: '安卓端安装失败？',
        android12: '原因：因该类软件的行业特殊性，下载/安装时可能会遇到各种阻碍。',
        android13: '如下载遇到问题，请参考以下解决方法（也可以在12:00-23:59期间点击右侧的客服图标联系客服）：',
        android14: '手机品牌：',
        android15: '华为/荣耀',
        android16: '小米/红米',
        android17: 'VIVO',
        android18: 'OPPO',
        android19: '一加',
        android20: '第 1 步：打开手机 <span class="bold">设置 --> 安全</span> --> 请看第2步 <br>',
        android21: '第 2 步：打开 <span class="bold">更多安全设置 --> 安装外部来源应用</span> --> 找到当前使用的浏览器给予相关安装权限（如uc浏览器） <br>',
        android22: '第 1 步：打开手机 <span class="bold">设置 --> 隐私保护</span> --> 请看第2步 <br>',
        android23: '第 2 步：点击“<span class="bold">管理</span>” <br>',
        android24: '第 3 步：点击“<span class="bold">特殊应用权限</span>” <br>',
        android25: '第 4 步：点击“<span class="bold">安装未知应用</span>” <br>',
        android26: '第 5 步：找到当前使用的浏览器给予相关安装权限（如Google浏览器） <br>',
        android27: '第 1 步：打开手机 <span class="bold">设置 --> 应用与权限</span> --> 请看第2步 <br>',
        android28: '第 2 步：点击“<span class="bold">权限</span>” <br>',
        android29: '第 3 步：点击“<span class="bold">安装未知应用</span>” <br>',
        android30: '第 4 步：找到当前使用的浏览器给予相关安装权限（如google浏览器） <br>',
        android31: '第 1 步：打开手机 <span class="bold">设置 --> 安全</span> --> 请看第2步 <br>',
        android32: '第 2 步：点击“<span class="bold">安装外部来源应用</span>” <br>',
        android33: '第 3 步：点击“<span class="bold">安装外部来源应用</span>”找到当前使用的浏览器给予相关安装权限（如google浏览器） <br>',
        android34: '第 1 步：打开手机 <span class="bold">设置 --> 应用和通知</span> <br>',
        android35: '第 2 步：点击“<span class="bold">特殊应用权限</span>” <br>',
        android36: '第 3 步：点击“<span class="bold">安装未知应用</span>” <br>',
        android37: '第 4 步：找到当前使用的浏览器给予相关安装权限（如google浏览器） <br>',


        /*   <span class="bold"></span>  */
        ios10: '绝尘帮助中心',
        ios11: 'iOS/Mac下载教程',
        ios12: '原因：因该类软件的行业特殊性，大陆暂时不支持上架。',
        ios13: '下载请参考以下解决方法（也可以在12:00-23:59期间点击右侧的客服图标联系客服）：',
        ios14: '请选择符合您的情形',
        ios15: '我有境外的苹果ID',
        ios16: '我只有大陆的苹果ID',
        ios17: '第 1 步：打开手机 <span class="bold">App Store</span> <br>',
        ios18: '第 2 步：如当前登录的是大陆ID，请点击“<span class="bold">头像</span>”icon。如已登录境外ID，请直接看第5步。 <br>',
        ios19: '第 3 步：点击头像后进入“账户” <br>',
        ios20: '第 4 步：滑至底部，点击“<span class="bold">登出</span>”--> 然后登录您的境外ID就好 <br>',
        ios21: '第 5 步：点击按钮跳转商城，或直接在商城搜索“绝尘加速器“或者”绝尘加速器官网” <br>',
        // collapse titles 
        ios22: '创建专属的境外苹果ID',
        ios23: '推荐',
        ios24: '自己的专属ID更安全，更方便',
        ios25: '点击展开教程',// down
        ios25up: '点击收起教程',//up
        ios26: '修改你的苹果ID地区',
        ios27: '在已有的苹果ID修改地区即可安装',//
        ios28: '使用共享的境外苹果ID',
        ios29: '谨记不要在设置里登录，请在App Store登录',
        // 
        ios30: '第 1 步：前往苹果官网ID注册页 --> 填写“ <span class="bold">姓名、国家或地区、邮箱、密码、手机号码</span>”即可 <br>',
        ios31: '第 2 步：<span class="bold">验证邮箱/手机号 </span>-->验证成功后请看下一步 <br>',
        ios32: '第 3 步：<span class="bold">添加付款方式</span>（从美国地址生成器把内容复制粘贴就行，前往<span class="bold"><a href="https://www.meiguodizhi.com/" target="_blank">美国地址生成器</a></span>） <br>',
        ios33: '第 4 步：打开“App Store”  <br>',
        ios34: '第 5 步：如当前登录的是大陆ID，请点击“<span class="bold">头像</span>”icon（ 如未登录请直接登录刚注册的ID） <br>',
        ios35: '第 6 步：进入“账户”后，滑至底部，点击“<span class="bold">登出</span>”，然后登录刚注册的ID <br>',
        ios36: '第 7 步：登录成功后，搜索“<span class="bold">绝尘加速器”或者“JCVPN”</span>，下载即可畅游全球 <br>',

        ios37: '前往苹果官方教程',


       windows11_1:'Windows 11连接之后没网解决办法?',
       windows11_2: '设备:',
       windows11_3: '电脑',
       windows11_4: '系统:',
       windows11_5: 'Windows 11',
       windows11_6: '版本号:',
       windows11_7: '24H2',
       windows11_8: '问题:',
       windows11_9: '连接没网',
       windows11_10: '首先，点击Windows图标，然后点击【设置】',
       windows11_11: '接下来点击左边的【系统】',
       windows11_12: '第四步将鼠标放到右边，下拉到最后，点击【可选功能】',
       windows11_13: ' 第五步，同样下拉到最后，点击【更多Windows功能】',
       windows11_14: ' 在弹出的窗口，找到【Virtual Machine Platform】',
       windows11_15: '然后点击【Virtual Machine Platform】前面的小方框，将其勾选上就完成了',
       windows11_16: '最后，将电脑重启，重新打开软件就可以正常使用了',

 
        client_windows:"Windows",
        client_android:"Android",
        client_ios:"下载iOS端",
        client_mac:"macOS",
        client_linux:"Linux", 

        
       payment_success1:"充值绝尘币",
       payment_success2:"复制",
       payment_success3:"支付成功",
       payment_success4:"感谢您的购买！如遇问题，请联系客服~",
       payment_success5:"订单号",
       payment_success6:"已复制订单号",
       payment_success7:"订单号未复制",


        
        privacy1:  '绝尘加速器（以下简称绝尘）通过在连接到Internet时建立安全的虚拟专用网络，将服务作为保护您隐私的一种手段。<br>',
        privacy2:  '绝尘尊重并保护所有使用绝尘网络服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务,绝尘会按照本隐私政策的规定使用和披露您的个人信息，但绝尘将以高度的勤勉、审慎义务对待这些信息。<br>',
        privacy3:  '除本隐私权政策另有规定外,在未征得您事先许可的情况下,绝尘不会将这些信息对外披露或向第三方提供。绝尘会不时更新本隐私权政策。您在同意绝尘络服务使用协议之时,即视为您已经同意本隐私权政策全部内容。本隐私权政策属于绝尘网络服务使用协议不可分割的一部分。',
        privacy4:  '1. 用户数据收集',
        privacy5:  '我们确保永远不会记录用户的浏览历史记录，访问的数据内容，以及DNS查询。因此：',
        privacy6:  '我们不知道哪个用户曾经访问过特定的网站或服务。',
        privacy7:  '我们不知道哪个用户在特定时间连接了加速器以及使用了哪个加速器服务器的IP地址。',
        privacy8:  '我们不知道用户计算机或者移动设备的原始IP地址。',
        privacy9:  '如果有人需要我们提供上述用户信息，我们将无法提供，因为数据不存在。',
        privacy10: '手机号和邮箱',
        privacy11: '我们后期在用户注册时，可能会选择性让用户绑定手机号和邮箱（选填），我们收集用户绑定的手机号或者邮箱，用于帮助用户找回账号密码，以及在反馈问题后及时收到我们的回复。',
        privacy12: '设备型号和系统版本',
        privacy13: '我们收集用户的设备型号和系统版本，用来统计哪些型号的设备或者操作系统，连接VPN后不太好用，便于我们针对性的调试和解决问题。',
        privacy14: '2. 信息使用',
        privacy15: 'a) 绝尘不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息,除非事先得到您的许可',
        privacy16: 'b) 绝尘亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何绝尘平台用户如从事上述活动,一经发现,绝尘有权立即终止与该用户的服务协议。',
        privacy17: 'c) 为服务用户的目的,绝尘可能通过使用您的个人信息,向您提供您感兴趣的信息,包括但不限于通过邮件或者短信等向您发出产品和服务信息。',
        privacy18: '3. 信息披露',
        privacy19: '在如下情况下,绝尘将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息:',
        privacy20: 'a) 经您事先同意,向第三方披露;',
        privacy21: 'b) 为提供您所要求的产品和服务,而必须和第三方分享您的个人信息;',
        privacy22: 'c) 根据法律的有关规定,或者行政或司法机构的要求,向第三方或者行政、司法机构披露;',
        privacy23: 'd) 如您出现违反所在国家地区的有关法律、法规或者绝尘服务协议或相关规则的情况,需要向第三方披露;',
        privacy24: 'e) 其它绝尘根据法律、法规或者网站政策认为合适的披露。',
        privacy25: '4. 信息安全',
        privacy26: 'a) 绝尘帐号均有安全保护功能,请妥善保管您的用户名及密码信息。绝尘将通过对用户密码进行加密等安全措施确保您的信息不丢失,不被滥用和变造。尽管有前述安全措施,但同时也请您注意在信息网络上不存在“完善的安全措施”。',
        privacy27: 'b) 如您发现自己的个人信息泄密,尤其是绝尘用户名及密码发生泄露,请您立即联络绝尘客服,以便绝尘采取相应措施。',
        privacy28: '5.改变',
        privacy29: 'a)我们保留自行决定随时修改或替换这些条款的权利。在这些修订生效后继续访问或使用我们的服务，您同意受修订条款的约束。如果您不同意新条款，请停止使用本服务。',
        privacy30: '我们可能随时和不时更改我们的条款。最新版本的条款反映在本协议顶部的版本日期。所有更新和修订在更新后立即生效。我们建议您经常查看我们的条款，以便随时了解可能对您产生的影响，因为您继续使用该申请表示您继续同意接受我们的条款约束。',
        privacy31: 'b)我们可以出于任何原因立即终止或暂停访问我们的服务，恕不另行通知或承担任何责任，包括但不限于您违反本条款。本条款的所有条款本质上应在终止后继续有效，包括但不限于所有权条款，保证免责声明，赔偿和责任限制。',
        privacy32: '6.适用法律',
        privacy33: '这些条款应受所在国家地区的法律管辖和解释，而不考虑其法律冲突规定。',
        privacy34: '我们未能执行这些条款的任何权利或规定将不被视为放弃这些权利。如果这些条款的任何条款被法院认定为无效或不可执行，则这些条款的其余条款将继续有效。这些条款构成我们之间关于我们服务的完整协议，并取代我们之间可能拥有的有关服务的任何先前协议。',

        terms1:  '一般的',
        terms2:  '我们的目标是为所有客户提供优质服务。在您访问本网站或服务之前，请仔细阅读这些服务条款。',
        terms3:  '本服务条款（以下简称“本条款”）约束您对 绝尘加速器 及其相关网站域名（以下简称“网站”）和相关服务（以下简称“服务”）的使用，这些服务由 绝尘 团队（以下简称“绝尘”、“我们的”、“我们”）拥有和运营。本条款构成您与 绝尘 团队之间具有法律约束力的协议（以下简称“协议”）。',
        
        terms4:  '绝尘加速器 服务',
        terms5:  '您了解我们为您提供虚拟专用网络（或“加速器”）服务，包括但不限于使用服务器、传输、路由器、IP 地址和其他设备和协议通过我们的网络（“系统”）传输信息。您同意遵守有关您使用服务的条款。',
        
        terms6:  '使用政策',
        terms7:  '通过使用 绝尘加速器 服务（“服务”），您同意：',
        terms8:  'a) 不得使用该系统发送垃圾邮件、端口扫描、扫描开放代理或开放中继、发送选择加入电子邮件、未经请求的电子邮件或任何类型或版本大量发送的电子邮件，即使该电子邮件最终是从另一台服务器发送的。',
        terms9:  'b) 不要从我们的服务启动任何弹出窗口。',
        terms10: 'c) 在使用我们服务时不得以任何方式攻击任何其他计算机或网络。',
        terms11: 'd) 不得使用该服务进行可能损害我们的网络或其他人的事情。',
        terms12: 'e) 用户有责任了解并理解与您和您的行为有关的任何司法管辖区或地点的所有相关法律。绝尘加速器 不以任何方式或形式对其用户的行为负责，包括刑事责任和对造成或未造成的损害的民事责任，超出具体个人向 绝尘加速器 支付的任何服务费用。',
        terms13: 'f) 违反本使用政策或条款可能会导致您的帐户被终止，并且不会退还之前为服务支付的任何金额。此外，您可能要对 绝尘 遭受的任何和所有损失负责，包括由于上述违规行为而由任何外部实体收取的任何金额，包括但不限于律师费和费用。',
        terms14: 'g) 绝尘加速器 可让您将软件、软件更新或补丁或其他实用程序和工具下载到您的手机或支持互联网的设备上。绝尘加速器（“软件”）授予您非独占的有限许可，仅允许您根据本条款将软件用于 绝尘加速器 在向您提供软件时所述的目的。严禁修改、分发给未经授权的各方、进行逆向工程或以任何未经 绝尘加速器 明确授权的方式使用软件。',
        
        terms15: '免责声明',
        terms16: 'a) 我们努力防止网站和服务中断。但是，这些内容是按“原样”和“可用”提供的，并且我们不以明示或暗示的方式保证通过网站或服务提供的任何材料或信息的准确性，也不保证其适用于任何特定用途。',
        terms17: 'b) 实际服务覆盖范围、速度、位置和质量可能有所不同。除维护和维修的有限时间外，服务将尝试随时可用。但是，服务可能会因我们无法控制的各种因素而不可用，包括紧急情况、第三方服务故障、传输、设备或网络问题或限制、干扰、信号强度，并且可能会中断、拒绝、限制或缩减。',
        terms18: 'c) 我们不保证服务将满足您的要求，也不保证服务不会中断、及时、安全或无错误，也不保证缺陷（如有）将得到纠正。您承认，您访问网站和服务完全出于您的判断并由您自行承担风险。',
        terms19: 'd) 对于因服务或通信服务或网络（例如 T-1 线路或互联网）中断或性能问题而导致的数据、消息或页面丢失、未送达、延迟或误传，我们概不负责。我们可自行决定限制使用量或服务、暂停服务或阻止某些类型的使用，以保护用户或服务。网络速度是估算值，并不表示您或服务发送或接收数据的速度。实际网络速度将根据配置、压缩、网络拥塞和其他因素而有所不同。我们无法保证所接收数据的准确性和及时性；可能会出现延迟或遗漏。',
        terms20: 'e) 我们不记录任何用户活动（访问的网站、DNS 查询、电子邮件等）。我们仅记录对我们服务器的访问尝试，以用于故障排除和改进服务。我们不参与任何形式的审查。我们不会将您的个人信息提供给任何第三方。',
        
        terms21: '条款变更',
        terms22: 'a) 绝尘加速器 可能会不时更新本条款，恕不另行通知。本条款的任何变更都将纳入修订后的协议，我们将在网站上发布该协议。除非另有规定，否则此类变更自发布之日起生效。如果我们对这些条款做出重大变更，我们将通过应用程序或在您查看我们的网站时通知您。',
        
        terms23: '最后',
        terms24: 'a) 绝尘加速器 深信消费者隐私、安全和网络自由，我们以此管理和保护消费者隐私和个人信息。如果您有任何问题或疑问，我们都会通过电子邮件地址<br>juechenvpn@gmail.com为您提供支持',
        

 

        home: 'Home',
        support:'Support',
        contactus:'Contact us',
        settings: 'Settings',
        change_locale: 'Change Language',
        dashboard: 'Dashboard',
        login_username: 'Username',
        login_password: 'Password',
        submit: 'Submit',
        logout: 'Logout', 
        add_new_user: 'Add new user',
        username: 'Username',
        password: 'Password', 
        email: 'Email',
        phone: 'Phone',
        activate: 'Activate',
        validity: 'Validity',
        active: 'Active',
        inactive: 'Inactive', 
        awaiting: 'Awaiting', 
        traffic_done: 'Traffic Done',
        status: 'Status', 
        display: 'Display',  
        permission: 'Permission',
        date_created: 'Date Created',
        date_update: 'Date Updated',
        action: 'Action',
        increase: 'Increase',
        decrease: 'Decrease',
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        go_back: 'Go Back',
        select: 'Select',  
        name: "Name",
        key: "Key", 
        bandwidth: 'Bandwidth',
        extra_bandwidth: 'Extra Bandwidth',
        bandwidth_high: 'Bandwidth High limit(GB)',
        bandwidth_low: 'Bandwidth Low limit(GB)', 
        bhigh: 'High',
        blow: 'Low', 
        confirm_delete: 'Are you sure to perform this action?', 
        save:'Save',
        billed: 'Billed',
        not_listed: 'Not Listed',
        sorting_order: 'Sorting order',
        description: 'Description',
        monthly: 'Monthly',
        weekly: 'Weekly',
        quarterly: 'Quarterly',
        biannual: 'Biannual',
        yearly: 'Yearly',
        manually: 'Manually',
        title: 'Title',
        for: "for",
        all: "All", 
        android: "Android", 
        ios: "IOS",
        languages: "Languages",
        price: 'Price',
        coins: 'Coins',
        extra_coins: 'Extra Coins',
        is_basic_plan: 'Basic Plan',
        discount: 'Discount',
        rate:'Rate',
        currencies: "currencies",
        detail: 'Detail',
        speed_limit: 'Speed limit',
        manage: 'Manage',
        payment: 'Payment',
        methods: 'Methods',
        mode: 'Mode',
        live: 'Live',
        test: 'Test',
        data: 'Data',
        icon: 'Icon',
        code: 'Code',
        channels: 'Channels',
        groups: 'Groups',
        group: 'Group',
        remark: 'Remark',
        info: 'Info',
        assign: 'Assign',
        to: 'to',
        method: 'method',
        shortcuts: 'Shortcuts',
        link: 'Link',
        view: 'View',
        list: 'List',
        users: 'Users',
        user: 'User',
        search: 'Search',
        servers: 'Servers',
        areas: 'Areas',
        types: 'Types',
        lists: 'Lists',
        information:'Information',
        main: 'Main',
        multiple:'Multiple',
        ip: 'IP',
        port: 'Port',
        ports: 'Ports',
        total: 'Total',
        clients: 'Clients',
        none: 'Not Selected',
        announcements: 'Announcements',
        created: 'Created',
        expired: 'Expired',
        at: 'at',
        url: 'Url',
        yes: 'Yes',
        no: 'No',
        base_currency: 'Base Currency',
        config: 'Config',
        configuration: 'Configuration',
        order: 'Order',
        orders: 'Orders',
        number: 'number',
        amount: 'Amount',
        package: 'Package',
        paid: 'Paid',
        un_paid: 'Unpaid',
        started: 'Started',
        completed: 'Completed',
        pending: 'Pending',
        cancelled: 'Cancelled',
        rejected: 'Rejected',
        refund: 'Refund',
        default: 'Default',
        allowed: 'Allowed',
        devices: 'Devices',
        additonal: 'Additonal',
        version: 'Version',
        version_old: 'Version old',
        sha256: 'sha256',
        pack_size: 'Pack size',
        force: 'Force',
        type: 'Type',
        force_type_zero: 'User chooses to update',
        force_type_one: 'Force to update all',
        currency: 'Currency', 
        apply: 'Apply', 
        refresh: 'Refresh',
        reset: 'Reset',
        close: 'Close',
        plan_time: 'Plan time',
        minutes: 'Minutes',
        days:"Days",
        packages: 'Packages',
        start: 'Start',
        end: 'End',
        date: 'Date',
        free: 'Free',
        premium: 'Premium',
        both: 'Both',
        transfer: 'Transfer',
        id: 'Id',
        url_config: 'Config',
        value: 'Value',
        extra: 'Extra',

        online: 'Online',
        today: 'Today',
        new: 'New',
        not: 'Not',
        confirmed: 'Confirmed',
        trial: 'Trial',
        reward: 'Reward',
        login: 'Login',
        level: 'Level',
        language: 'Language',
        invite: 'Invite',
        referrer: 'Referrer',
        faq: 'FAQ',
        question: 'Question',
        answer: 'Answer',
        blog: 'Blog',
        slug: 'Slug',
        viewed: 'Viewed',
        image: 'Image',
        meta: 'Meta',
        text: 'Text',
        optional: 'Optional',
        keywords: 'keywords',
        welcome: 'Welcome',
        console: 'Console',
        author: 'Author',
        category: 'Category', 
        categories: 'Categories',
        months: 'Months',
        recommended: 'Recommended',
        news: 'News',
        ticket: 'Tickets',
        subject: 'Subject',
        resolved: 'Resolved',
        replied: 'Replied',
        spam: 'Spam',
        reply: 'Reply',
        message: 'Message', 
        messages: 'Messages',
        admin:'Admin',
        admin_operation_logs: 'Admin Operation Logs',
        restricted: 'Restricted',
        area: 'Area',
        reports: 'Reports',
        registered: 'Registered',
        last_7_days: 'Last 7 days',
        last_30_days: 'Last 30 days',
        last_90_days: 'Last 90 days',
        last_365_days: 'Last 1 year',
        last_2_years_days: 'Last 2 Years',
        last_3_years_days: 'Last 3 Years', 
        days_count:' Days Count',
        _1_days: ' 1 Days',
        _3_days: ' 3 Days',
        _7_days: '7 Days',
        _30_days: '30 Days',
        _90_days: '90 Days',
        _180_days: '180 Days',
        _1_years_days: '1 year (360 Days) ',
        _2_years_days: '2 Years (730 Days)',
        _3_years_days: '3 Years (1095 Days)',
        client: 'Client',
        tutorial: 'Tutorial',
        paying: 'Paying',
        other: 'other',
        yesterday: 'Yesterday',
        custom_date_filter: 'Custom date',
        vpn: 'VPN',
        lattitude: 'lattitude',
        longitude: 'longitude',
        max_network_bandwidth: 'Max network bandwidth',
        network_bandwidth: 'Network bandwidth',
        load: 'load',
        mid: 'MID',
        hourly: 'Hourly',
        udid: 'udid',
        token: 'Token',
        first: 'First',
        time: 'Time',
        bugs: 'Bugs',
        user_id: 'User ID',
        node_id: 'Node',
        log_detail: 'Log Detail',
        device_detail: 'Device Detail',
        client_id: 'Client_ID',
        unique_no: 'Unique No',
        clients_error: 'Errors',
        renewals: 'Renewals',
        download: 'download',
        last_active_time: 'Last active time',
        temp: 'Temp',
        offer: 'offer',
        push_notification: 'Push Notification',
        send: 'Send',
        sent: 'Sent',
        not_sent: 'Not Sent',
        device: 'Device',
        whitelist: 'Whitelist',
        points: 'Points',
        total_points: 'Total Points',
        deep_link: 'Deep Link',
        is_offer: 'Is Offer',
        is_disabled: 'Is Disabled',
        gift_code_builder: 'Gift Code Builder',
        batch: 'Batch',
        count: 'Count',
        purpose: 'Purpose',
        plan: 'Plan', 
        plans: 'Plans',
        generated_by: 'Generated By',
        receive_money: 'Receive Money',
        finance_comment: 'Finance comment',
        gift_codes: 'Gift Codes',
        cancel: 'Cancel',
        generate: 'Generate',
        btach_name: 'Batch Name',
        sr_no: 'SR.NO',
        card_code: 'Card-Code',
        redeem_status: 'Redeem Status',
        used_time: 'Used Time', 
        used: 'Used',
        demo: 'Preview', 
        refer_friend:"Refer Friend",
        verify_email: "Verify Email", 
        by: "by",  
        last: "Last", 
        preffered_language: "Preffered language",
        preffered_theme: "Preffered theme", 
        verification_code: "Verification Code",
        refferal_id: "Refferal ID",
        order_history: "Order history",
        packages_history: "Packages history",
        order_not_find:"No Orders found",
        packages_not_find:"No packages found",
        earn_points_not_found:"No Earn points found",
        redeem_points_not_found: "No Redeem Points found",
        devices_not_found: "Devices not found",
        tickets_not_found: "Tickets not found",
        lookup: "Lookup",
        transaction_id: "Transaction ID",
        check: "Check",
        allowed_countries: "Allowed Countries",
        guest: "Guest",
        redeem: "Redeem",
        account: "Account",
        current: "Current",
        change_password_heading: "Please change your password",
        country: 'Country', 
        domains: 'Domains',
        domain: 'Domain',
        weight: 'Weight',  
        protocol:'Protocol',
        available:"Available",
        order_number_not_found:"Order not found with this order number.",
        order_username_different:"Order username not matched with given username.",
        package_not_found:"Package not found.",
        balance:"Balance",
        in:"In",
        out:"Out",
        deleted:"Deleted",

        



        windows_doc:"Windows下载失败？",
    
        share_1: "share",
        share_2:"Invite new people and get endless gifts",
        share_3:"Scan & download client",
        share_4:"Can't open? Please scan with a non-system browser",
        share_5:"My invitation code",
        share_6: "Link invitation",
        share_7: "Image Saving",
        share_8: "Invited persons",
        share_9: "Earnings(yuan)",
        share_10: "Sharing Rewards",
        share_11: "Give XX points",
        share_12: "When the subordinate user successfully fills in your invitation code, the system will automatically give points, which can be exchanged for packages.",
        share_13: "Recharge rebate, up to",
        share_14: "If the subordinate user and his/her next two levels of users recharge, you will receive a commission.",
        share_15: "Commissions are issued in the form of points, and commission points can be withdrawn.",
        share_16: "User Level",
        share_17: "First Charge",
        share_18: "Renewal",
        share_19: "Level 1",
        share_20: "Level 2",
        share_21: "Level 4",
        share_22: "What are first, second, and third level users?",
        share_23: "Strictly prohibit fraudulent use. Once detected, the system will delete the reward or block the account.",
        share_24: "The final right of interpretation belongs to [Juechen Accelerator]",
        share_25: "Copied successfully",
        share_26: "Waiting...",
        dialog_share_tips_1: "Copied successfully",
        dialog_share_tips_2: "If your friend cannot open the shared link, please ask your friend to open it using a non-system browser.",
        dialog_share_tips_3: "got it",



        referral_rewards_title: "Lower level users and commission ratio",
        referral_rewards_des: "Your sub-user definition and the commission ratio you can receive",
        referral_rewards_card_1: "You",
        referral_rewards_card_2: "NUS A",
        referral_rewards_card_3: "NUS B",
        referral_rewards_card_4: "NUS C",
        referral_rewards_level_1: "Level 1",
        referral_rewards_level_2: "Level 2",
        referral_rewards_level_3: "Level 3",
        referral_rewards_label_1: "You share",
        referral_rewards_label_2: "A Share",
        referral_rewards_label_3: "B Share",
        referral_rewards_label_4: "First",
        referral_rewards_label_5: "",
        referral_rewards_label_6: "Renewal",
        referral_rewards_label_7: "",
        referral_rewards_label_br: "block",
        referral_rewards_definition_show: "block",
        referral_rewards_definition: "Definition: NUS means New User",



        share_link_1: 'Dust-free accelerator',
        share_link_2: 'Unhindered access to all platforms around the world',
        share_link_3: 'Your friend is inviting you to download "Juechen Accelerator"',
        share_link_4: 'Your friend invitation code',
        share_link_5: 'Permanently free, no tricks, built by a top-tier tech team',
        share_link_6: 'Unlimited speed',
        share_link_7: 'Hide your real IP',
        share_link_8: 'Secure and private connection',
        share_link_9: 'Android/Hongmeng Download',
        share_link_10: 'Go to the official website to download more',
        share_link_11: 'Official contact address',
        share_link_12: 'Juechen official website',
        share_link_13: ' (If you cannot open it, please open it after climbing over the firewall)',
        share_link_14: 'juechenjsq.co',
        share_link_15: 'Juechen TG User Group',
        share_link_16: ' (Need to climb over the wall)',
        share_link_17: 'https://t.me/juechenvpn1',
        share_link_18: 'Online Customer Service',
        share_link_19: '（12:00-23:59）',
        share_link_21: 'Official Email',
        share_link_22: ' (Business Cooperation/Contact Customer Service)',
        share_link_23: 'juechenvpn@gmail.com',
        share_link_24: 'If it fails to open, please connect to a VPN and try again.',
    
        share_image_part_1: 'Scan the QR code to download the client and browse the entire network',
        share_image_part_2: "Can't open? Please scan with a non-system browser",

        points_details_1: 'Points Details',
        points_details_2: 'Commission points have a 10-day lock-up period. After 10 days, they will be counted as available points and can be withdrawn.',
        points_details_3: 'Points Details',
        points_details_4: 'No records',
        points_details_5: 'Total Rebate',
        points_details_btn_arr : ['All', 'Credited', 'Pending', 'Spent', 'Refunded/Deducted','Added','Withdrawn','Reclaimed','Refunded'],
        invitation_reward: 'Invitation Rewards',
        points_details_filter_arr: ['Last 3 months', 'Last 6 months', 'Last year', 'Last 2 years'],


        purchase_level_1: 'L1 Purchase',
        purchase_level_2: 'L2 Purchase',
        purchase_level_3: 'L3 Purchase',
        renwal_level_1: 'L1 Renewal',
        renwal_level_2: 'L2 Renewal',
        renwal_level_3: 'L3 Renewal',
        deducted_level_1: 'L1 Refund',
        deducted_level_2: 'L2 Refund',
        deducted_level_3: 'L3 Refund',
        share_earned: 'Invite User',
        redeem_package: 'Redeem Package',
        withdraw: 'Withdraw',
        test_points: 'Other',

        my_points_1: 'My Points',
        my_points_2: 'Available points',
        my_points_3: 'Including cashable points',
        my_points_4: 'Withdrawal',
        my_points_5: 'Pending(points)',
        my_points_6: 'Total Rewards',
        my_points_7: 'Task center',
        my_points_8: 'Share and earn cash',
        my_points_9: 'commission',
        my_points_10: 'Invite new users to earn commissions',
        my_points_11: 'Go share',
        my_points_12: 'Exchange points for gifts',
        my_points_13: 'There is no redemption gift available at the moment, please stay tuned~',
        my_points_14: 'Day',
        my_points_15: ' Points',
        my_points_16: 'Hour',
        my_points_17: 'minute',
        my_points_18: 'Redeem successfully',
        my_points_19: 'Package redeemed successfully',
        my_points_20: 'Redeem failure',
        my_points_21: 'The available points are not enough to redeem the package',
        my_points_22: 'Redeem traffic package',
        my_points_23: 'Use',
        my_points_24: ' points',
        my_points_25: 'Exchange',
        my_points_26: 'Cancel',
        my_points_27: 'data package',
        my_points_28: 'to redeem',
        my_points_29: 'Owner',
        my_points_30: 'Change',
        my_points_31: 'please enter username',
        my_points_32: 'username length should be 5-16 characters',
        my_points_33: "username incorrect or doesn't exist",
        my_points_34: "Confirm exchange information",
        my_points_35: "Sure",
        my_points_36: "Exchange successful",
        my_points_37: "The package has been redeemed successfully. You can return to the personal center to view it.",
        my_points_38: "knew",
        my_points_39: "Available points",
        my_points_40: ", cannot be redeemed",
        my_points_41: "",


        withdraw_1: "Withdrawal",
        withdraw_2: "History",
        withdraw_3: "Available (CNY)",
        withdraw_4: "Total Withdrawn",
        withdraw_5: "points",
        withdraw_6: "Transfer Amount",
        withdraw_7: "≈ Point",
        withdraw_8: "Min Withdrawal",
        withdraw_9: "Min: 100 CNY",
        withdraw_10: "Transfer to",
        withdraw_11: "Alipay",
        withdraw_12: "6% Fee",
        withdraw_13: "Change",
        withdraw_14: "Account",
        withdraw_15: "Enter Alipay Account",
        withdraw_16: "Full Name",
        withdraw_17: "For Transfer Verification",
        withdraw_18: "Processing: ~7 Days ",
        withdraw_19: "Submit",
        withdraw_20: "Exchange Rate: Live",
        withdraw_21: "Address",
        withdraw_22: "Enter USDT Address",
        withdraw_23: "Select Payment Method",
        withdraw_24: "Cancel",
        withdraw_25: "Special characters (e.g., @, &, _, ^, .) and letters are not allowed. Please enter numbers",
        withdraw_26: "Insufficient Withdrawable Balance", 
        withdraw_27: "Minimum withdrawal amount is 100 CNY",
        withdraw_28: "Confirm Information",
        withdraw_29: "Withdraw",
        withdraw_30: "Fee 4U",
        withdraw_31: "Confirm & Submit",
        withdraw_32: "Numbers, English and symbols only",


        withdraw_suc_1: "Withdrawal",
        withdraw_suc_2: "Submitted Successfully",
        withdraw_suc_3: "Processing ~7 Days",

        withdrawn_history_1: 'History',
        external_links_title: 'Popular navigation',
        withdrawn_history_2: 'Withdrawal',
        withdrawnStatusArr: ['Processing','Success','Canceled','Failed'],


        error_share_1 : "Oops! Something went wrong.",
        error_share_2 : "Page loading error",
        error_share_3 : "Back to Home",

        defaultFeatureName: 'Next',
        defaultMessage: 'This is a sample message',
        defaultFeatureCatiguryName:'Feature',

        cat_1:'Hot',
        cat_2:'Cat 1',
        cat_3:'Cat 2',
        cat_4:'Cat 3',
        cat_5:'Cat 4',
        cat_6:'Cat 5',
        cat_7:'Cat 6',
        recent_msg_title: "Today's News",

        title_section_1: "This month's reward",
        months_rewards: 'July 1st - July 31st',
        reward_records_btn: 'Reward Records>',
        sp1: 'Invite new users, the highest reward',
        sp2: ' 70 day package + points + ',
        sp2_com: '% rebate',
        invint_note: 'Once the system detects the user as a valid user, it will be counted as a valid invitation immediately.',
        people: ' Persons',
        invites: '',
        orange_label: 'Free 20 days 40GB',
        title_section_2: "This month's benefits",
        title_note_2: 'Optional packages or points',
        list_gifts_title1: 'Recharge rebate, up to ',
        list_gifts_des11: 'After new users fill in the invitation code, they can receive ',
        list_gifts_des11_com: '% of their first charge order amount as a rebate.',
        list_gifts_des12: 'Distributed in the form of points, which can be withdrawn or exchanged for packages',
        to_invite: 'Go to invite',
        get_rewards: 'Get Rewards',
        received: 'Received',
        share_link_55: 'Invite new users and get endless gifts',
        share_title: 'Invite newcomers',
        rewards_rules:'Reward Rules',
        item_sec3_1: 'Total invites(person)',
        item_sec3_2: 'Valid invites(person)',
        item_sec3_3: 'Standard points',
        item_sec3_4: 'Commission points',
        rewards_dialog_title: 'Reward Record',
        note_rewards_dialog: 'Points are recorded in the Points Center, and packages are recorded in the Package List in the Personal Center',
        apply_gift_dialog_des:'Congratulations on completing the challenge. Please choose to receive a package or points.',
        or:'or',
        apply_package:'Get your package',
        apply_points:'Collect points',
        apply_p:' Points',
        suc_title_gift_dialog: 'Successfully received',
        suc_des_gift_dialog:'Your reward has been successfully received',
        des_extra_points_1: 'After inviting more than ',
        des_extra_points_2: ' people this month, you’ll earn ',
        des_extra_points_3: ' points for each additional invite. The points will be automatically issued on the 1st of the following month.',
        current_points_b1: '',
        current_points_b2: ' points to be issued',
        reward_rules_1: 'Invitation Mission Rewards',
        reward_rules_2: 'Successful invitation',
        reward_rules_3: 'Valid new users',
        reward_rules_4: ', you can complete the stage tasks and receive rewards;',
        reward_rules_5: 'Rewards:',
        reward_rules_6: 'Ordinary points / package benefits (choose one of the two), ordinary points can be used to redeem packages.',
        reward_rules_7: 'Valid users:',
        reward_rules_8: 'You need to fill in the invitation code and meet the system judgment criteria',
        reward_rules_9: 'Those who fail to meet the target will not be included in the task progress.',
        reward_rules_10: 'Distribution Instructions',
        reward_rules_11: 'You can collect it at any time after completing the task',
        reward_rules_12: 'If you do not claim it in the current month, the system will automatically issue the reward on the 1st of the next month',
        reward_rules_13: 'First deposit reward for lower-level users',
        reward_rules_14: 'When subordinate users fill in the invitation code and recharge, you will receive 40% of their order amount in the form of commission points;',
        reward_rules_15: 'If the other party',
        reward_rules_16: 'Recharge first and then fill in the invitation code',
        reward_rules_17: ', not counted towards rewards.',
        reward_rules_18: 'Distribution Instructions',
        reward_rules_19: 'Automatically issued immediately after purchase, with a 10-day lock-up period;',
        reward_rules_20: 'After unlocking, commission points can be used to withdraw cash or redeem packages.',
        reward_rules_21: 'Strictly prohibit fraudulent use. Once detected, the system will delete the reward or ban',
        dialog_save_img_tips_1: 'Sucess',
        dialog_save_img_tips_2: 'Saved image successfully',
        dialog_save_img_tips_3: 'Save failed',
        dialog_save_img_tips_4: 'If the retry still fails, you can resolve it by updating the software.',
        claim_faild:'Claim failed, Please try again',
        defaultUserSubmission: 'username',
        defaultTextSubmission: 'description',
        loadingUserSubmission: 'Loading...',
        loadingTextSubmission: '',
        desSubmission: 'Describe your content to us.',
        formSubmissionTitle: 'Publish your content:',
        submittedSuccess: 'Submitted successfully.',
        noSubmissions: "No content yet.",
        publishContent: 'Publish content',
        titleSubmissionsPage: 'Publish URL/App',
        submissionsIns1: 'Publishing Rules: Please strictly follow the format below to publish, otherwise it will be considered invalid. Thank you for your understanding and cooperation!',
        submissionsIns2: '1. Product Name:',
        submissionsIns3: '2. Website:',
        submissionsIns4: '3. Logo：',
        submissionsIns5: '4. Introduction:',
        submissionsIns6: '5. Is VPN required for access? (If only for specific regions, please note):',
        submissionsIns7: '6. Supported clients:',
        submissionsIns8: '7. Your email/Telegram (optional):',
        expandedTextBtn: 'Hide example',
        notExpandedTextBtn: 'Expand Example',
        submissionExp1: '1. Product Name: Dust Accelerator',
        submissionExp2: '2. Website:www.juechenjsq.co',
        submissionExp3: "3. Logo：www.juechenjsq.co\\logo.icon",
        submissionExp4: '4. Introduction: It is a permanently free VPN with no limit on the number of devices',
        submissionExp5: '5. Do you need a VPN to access? No',
        submissionExp6: '6. Supported clients: Android, iOS, Windows, Mac OS',
        submissionExp7: '7. Your email/Telegram (optional): juechenvpn@gmail.com',
        loading_more: 'Loading more',
        external_links_error_page1:'Popular navigation',
        external_links_error_page2:'Loading failed',
        external_links_error_page3:'Please try again',
        external_links_error_page4:'Reload',
        my_points_error: 'My Points',
        points_details_error: 'Points Details',
        withdrawal_error: 'Withdraw',
        withdrawal_history_error: 'Withdrawal records',
        share_error: 'Invite newcomers',
        external_links_error: 'Popular navigation',
        external_links_dialog_title: 'Disclaimer',
        external_links_dialog_des1: '1. This Service may contain advertisements and content from third parties. Such advertisements or content are unrelated to this Service; their accuracy, completeness, and legality are the responsibility of the respective third parties, and this Service assumes no liability for them.',
        external_links_dialog_des2: '2. Any transactions and legal liabilities arising from your clicking on advertisements or purchasing third-party products or services are to be resolved between you and the third party. This Service makes no warranties regarding such transactions and assumes no responsibility.',
        loading_file_error: 'Something went wrong, please try again later.',
        contentPublishingTabVisible:'yes',
        downloadAppWithJumping: 'yes',
        androidDownloadingInWindowsClient: 'no',
        deleteWindowsBtn: 'no',
        feature_title: 'Feature',
        feature_desc: 'Description',
        feature_dialog_title: 'Advertising sponsorship'
    }  

}
